import { Affix, Button, Card, Form } from "antd";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useNavigate } from "react-router-dom";
import CertificateOfOriginFeeForm from "../CertificateOfOriginFeeForm";

const AddCertificateOfOriginFee = (props) => {
  const { width } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const discardForm = () => {
    navigate("/import-export-expense-tracking/certificate-of-origin-fee");
  };

  const addNewCertificateOfOriginFee = () => {
    form.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title="Add New Certificate of Origin Fee"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discardForm()}>
                Discard
              </Button>,
              <Button
                size="small"
                key={2}
                type="primary"
                onClick={() => addNewCertificateOfOriginFee()}
              >
                Add Certificate of Origin Fee
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <CertificateOfOriginFeeForm form={form} />
    </>
  );
};

export default AddCertificateOfOriginFee;
